import { useEffect, useState, useRef, useCallback } from 'react';
import {
    FormGroup,
    FormControlLabel,
    Checkbox,
    Typography,
    Divider,
    FormControl, MenuItem, InputLabel, Select
} from '@mui/material';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { toast, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useNavigate, useLocation } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import axiosInstance from '../../../../lib/axios';
import checkAndLock from '../../../../GlobalFunction/checkAndLock';
import UnLock from '../../../../GlobalFunction/UnLock';
import CrudButtons from '../../../../GlobalFunction/CrudButtons';
import ReportTable from '../../../../atoms/ReportFolder/ReportTable';
import { useReactToPrint } from 'react-to-print';
import ClearIcon from '@mui/icons-material/Clear';
import IconButton from '@mui/material/IconButton';
import { getRoomMasterdropdata } from '../../../../Api/PropertyMst/Api';
import { selectGlobalProperty } from '../../../../redux/propertySlice';
import { useSelector } from 'react-redux';


const columns = [
    { id: 'RowNum', label: 'S.No.', minWidth: 100 },
    { id: 'HkWrkStnName', label: 'Work Station', minWidth: 150 },
    { id: 'HkWrkAreaName', label: 'Work Area', minWidth: 150 },
    { id: 'Abrv', label: 'Abbreviation', minWidth: 100 },
];

const PropertyWisestation = () => {
    const [searchQuery, setSearchQuery] = useState('');
    const [isPreviousDisabled, setIsPreviousDisabled] = useState(false);
    const [isNextDisabled, setIsNextDisabled] = useState(false);
    const [dropdownData, setDropdownData] = useState([]);
    const [selectedProperty, setSelectedProperty] = useState([]);
    const [formData, setFormData] = useState({
        Property: '',

    });
    const [deleteConfirmDialog, setDeleteConfirmDialog] = useState(false);
    const [stationToDelete, setStationToDelete] = useState(null);
    const navigate = useNavigate();
    const [isFormDisabled, setIsFormDisabled] = useState(true);
    const [currentYojana, setCurrentYojana] = useState(null);
    const [mode, setMode] = useState('view');
    const [status, setStatus] = useState("1");
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [userId] = useState(sessionStorage.getItem('UserId'));
    const [dataForPrint, setDataForPrint] = useState({});
    const [rows, setRows] = useState([]);
    const [selectedYojanas, setSelectedYojanas] = useState([]);
    const [selectedWorkAreas, setSelectedWorkAreas] = useState([]);
    const [originalRows, setOriginalRows] = useState([]);
    const [isRetrieveLoading, setIsRetrieveLoading] = useState(false);
    const [hasRetrievedData, setHasRetrievedData] = useState(false);
    const globalProperty = useSelector(selectGlobalProperty);

    useEffect(() => {
        if (globalProperty && globalProperty !== formData.Property) {
            setFormData(prevState => ({
                ...prevState,
                Property: globalProperty.toString()
            }));
        }
    }, [globalProperty]);

    const contentRef = useRef(null);
    const handlePrint = useReactToPrint({ contentRef });

    const handlePrevious = async () => {
        if (currentYojana && currentYojana > 1 && !isPreviousDisabled) {
            // await fetchYojanaData(currentYojana, "P");
        }
    };

    const handleNext = async () => {
        if (currentYojana) {
            // await fetchYojanaData(currentYojana, "N");
        }
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
        setHasRetrievedData(false);
        setRows([]);
        setSelectedWorkAreas([]);
        setOriginalRows([]);
    };

    const handleRetrieve = useCallback(async () => {
        if (!formData.Property) {
            toast.error('Property is required');
            return;
        }

        setIsRetrieveLoading(true);
        try {
            setSelectedWorkAreas([]);

            const payload = {
                PropId: parseInt(formData.Property),
                "HkWrkStnId": 0,
                "Flag": ""
            };

            const response = await axiosInstance.post('/MstYojana/RetriveMstPropWiseWrkStn', payload);

            if (response.data.Status === 0 && response.data.Data && response.data.Data.length > 0) {
                const apiData = response.data.Data;

                const workStationRows = apiData.map((item, index) => ({
                    RowNum: index + 1,
                    HkWrkStnId: item.HkWrkStnId,
                    HkWrkStnName: item.HkWrkStnName,
                    HkWrkAreaName: item.HkWrkAreaName || 'N/A',
                    Abrv: item.Abrv || 'N/A',
                    IsAllocated: item.Id > 0
                }));

                setRows(workStationRows);
                setOriginalRows(workStationRows);

                const allocatedStations = workStationRows
                    .filter(row => row.IsAllocated)
                    .map(row => ({
                        HkWrkStnId: row.HkWrkStnId,
                        HkWrkStnName: row.HkWrkStnName
                    }));

                setSelectedWorkAreas(allocatedStations);
                setHasRetrievedData(true);

            } else if (response.data.Status === 1) {
                toast.info(response.data.Message || 'No work stations found');
                setRows([]);
                setOriginalRows([]);
                setSelectedWorkAreas([]);
                setHasRetrievedData(true);
            } else {
                toast.error('Failed to retrieve data');
                setRows([]);
                setOriginalRows([]);
                setSelectedWorkAreas([]);
            }

        } catch (error) {
            toast.error('Error retrieving work stations');
            setRows([]);
            setOriginalRows([]);
            setSelectedWorkAreas([]);
        } finally {
            setIsRetrieveLoading(false);
        }
    }, [formData.Property]);

    useEffect(() => {
        const fetchDataOnPropertyChange = async () => {
            if (formData.Property) {
                await handleRetrieve();
            }
        };

        fetchDataOnPropertyChange();
    }, [formData.Property, handleRetrieve]);

    const handleCheckboxChange = async (station, isChecked) => {
        if (isChecked) {
            setSelectedWorkAreas(prev => [...prev, {
                HkWrkStnId: station.HkWrkStnId,
                HkWrkStnName: station.HkWrkStnName
            }]);
        } else {
            if (station.IsAllocated) {
                setStationToDelete({
                    station: station,
                    propId: formData.Property
                });
                setDeleteConfirmDialog(true);
            } else {
                setSelectedWorkAreas(prev => prev.filter(item => item.HkWrkStnId !== station.HkWrkStnId));
            }
        }
    };


    const handleSubmit = async () => {
        let hasError = false;

        if (!formData.Property) {
            toast.error('Property is required');
            hasError = true;
        }

        if (selectedWorkAreas.length === 0) {
            toast.error('Please select at least one Work Station');
            hasError = true;
        }

        if (hasError) return;

        try {
            const payload = selectedWorkAreas.map(station => ({
                PropId: parseInt(formData.Property),
                HkWrkStnId: station.HkWrkStnId
            }));

            const response = await axiosInstance.post(`/MstYojana/MangeMstPropWiseWrkStn`, payload);

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                toast.success(response.data.Message || 'Property wise station allocation saved successfully.');
                const updatedRows = rows.map(row => ({
                    ...row,
                    IsAllocated: selectedWorkAreas.some(item => item.HkWrkStnId === row.HkWrkStnId)
                }));

                setRows(updatedRows);
                setOriginalRows(updatedRows);

            } else {
                toast.info(response.data.Message || 'Operation failed.');
            }
        } catch (error) {
            toast.error('Error while saving Property wise station allocation.');
        }
    };

    const handleEdit = async () => {
        let flag = await checkAndLock(currentYojana, "MstYojana", "YojanaId");
        switch (flag) {
            case 0:
                setMode("edit");
                setIsFormDisabled(false);
                break;
            case 1:
                toast.info("Record Already Locked.", { autoClose: 500 });
                break;
            case 2:
                toast.error("Record Failed To Lock.", { autoClose: 500 });
                break;
            default:
                toast.error("Something Went Wrong.", { autoClose: 500 });
        }
    };

    const handleAdd = () => {
        setMode('add');
        setIsFormDisabled(false);
        setCurrentYojana(null);
        setStatus("1");
        setSelectedWorkAreas([]);
        setSelectedYojanas([]);
        setHasRetrievedData(false);
        setRows([]);
    };

    const handleCancel = async () => {
        try {
            if (mode === 'edit' && currentYojana) {
                await UnLock(currentYojana, "MstYojana", "YojanaId");
            }

            if (formData.Property) {
                await handleRetrieve();
            }

            setIsFormDisabled(true);
            setMode('view');

        } catch (error) {
            console.error('Error occurred while cancelling:', error);
            toast.error('Error occurred while cancelling. Please try again.');
        }
    };

    useEffect(() => {
        const fetchDropdownData = async () => {
            try {
                const response = await getRoomMasterdropdata({
                    Flag: "",
                    UserId: userId,
                });
                if (response?.data?.Status === 0) {
                    const dropdownItems = response.data.Data?.map((item) => ({
                        id: item.PropId,
                        name: item.Name,
                    }));
                    setDropdownData(dropdownItems);
                    if (globalProperty) {
                        const globalPropExists = dropdownItems.find(item =>
                            item.id.toString() === globalProperty.toString()
                        );

                        if (globalPropExists) {
                            setFormData(prev => ({
                                ...prev,
                                Property: globalProperty.toString()
                            }));
                        } else if (dropdownItems.length > 0) {
                            setFormData(prev => ({
                                ...prev,
                                Property: dropdownItems[0].id.toString()
                            }));
                        }
                    } else if (dropdownItems.length > 0) {
                        setFormData(prev => ({
                            ...prev,
                            Property: dropdownItems[0].id.toString()
                        }));
                    }

                }
            } catch (error) {
                toast.error("Error fetching property data");
            }
        };
        fetchDropdownData();
    }, [userId]);

    const handleExit = () => {
        navigate('/masters/operations');
    };

    const handleDeleteClick = () => {
        setOpenConfirmDialog(true);
    };

    const filteredRows = rows.filter(row =>
        searchQuery === '' ||
        (row.HkWrkAreaName && row.HkWrkAreaName.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (row.HkWrkStnName && row.HkWrkStnName.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (row.Abrv && row.Abrv.toLowerCase().includes(searchQuery.toLowerCase()))
    );
    const deletePropertyWiseStation = async (propId, hkWrkStnId) => {
        try {
            const response = await axiosInstance.post(`/MstYojana/DeleteMstPropWiseWrkStn`, {
                PropId: parseInt(propId),
                HkWrkStnId: parseInt(hkWrkStnId)
            });

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                toast.success(response.data.Message || 'Station removed successfully.');
                return true;
            } else {
                toast.info(response.data.Message || 'Failed to remove station.');
                return false;
            }
        } catch (error) {
            toast.error('Error while deleting property wise station.');
            return false;
        }
    };

    const handleConfirmDeleteStation = async () => {
        if (stationToDelete) {
            const { station, propId } = stationToDelete;

            const success = await deletePropertyWiseStation(propId, station.HkWrkStnId);

            if (success) {
                const updatedRows = rows.map(row =>
                    row.HkWrkStnId === station.HkWrkStnId
                        ? { ...row, IsAllocated: false }
                        : row
                );

                setRows(updatedRows);
                setOriginalRows(updatedRows);

                setSelectedWorkAreas(prev => prev.filter(item => item.HkWrkStnId !== station.HkWrkStnId));
            }

            setDeleteConfirmDialog(false);
            setStationToDelete(null);
        }
    };

    const handleCancelDeleteStation = () => {
        const station = stationToDelete?.station;
        if (station) {
            setSelectedWorkAreas(prev => {
                const isAlreadySelected = prev.some(item => item.HkWrkStnId === station.HkWrkStnId);
                if (!isAlreadySelected) {
                    return [...prev, {
                        HkWrkStnId: station.HkWrkStnId,
                        HkWrkStnName: station.HkWrkStnName
                    }];
                }
                return prev;
            });
        }

        setDeleteConfirmDialog(false);
        setStationToDelete(null);
    };

    return (
        <>
            <Box className="form-container" sx={{
                width: { xs: "calc(100vw - 60px)", sm: "auto", md: "auto" },
                maxWidth: { xs: "calc(100vw - 60px)", sm: "auto", md: "auto" },
                height: { xs: "91.5vh", sm: "93.5vh", md: "auto", lg: "92vh" },
                overflowX: "hidden",
                overflowY: { xs: "auto", sm: "hidden", md: "hidden", lg: "hidden" },
            }}>
                <ToastContainer />
                <Grid container spacing={1} className="form_grid">
                    <Grid
                        item
                        xs={12}
                        className="form_title"
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            marginTop: '20px',
                            flexDirection: { xs: 'column', sm: 'row', md: 'row' },
                        }}
                    >
                        {/* <Grid
                            sx={{
                                display: 'flex',
                                justifyContent: { xs: 'center', sm: 'flex-start' },
                                marginBottom: { xs: '7px', sm: 0 },
                            }}
                        >
                            <Button
                                variant="contained"
                                size="small"
                                className="three-d-button-previous"
                                onClick={handlePrevious}
                                sx={{ backgroundColor: '#635BFF', marginRight: { xs: '5px', sm: '7px' }, display: 'block' }}
                                disabled={mode !== 'view' || !currentYojana || currentYojana === 1 || isPreviousDisabled}
                            >
                                <KeyboardArrowLeftIcon />
                            </Button>
                            <Button
                                variant="contained"
                                size="small"
                                className="three-d-button-next"
                                onClick={handleNext}
                                sx={{ backgroundColor: '#635BFF', display: 'block' }}
                                disabled={mode !== 'view' || !currentYojana || isNextDisabled}
                            >
                                <NavigateNextIcon />
                            </Button>
                        </Grid> */}

                        <Typography
                            variant="h5"
                            sx={{
                                margin: 'auto',
                                textAlign: { xs: 'center', sm: 'center' },
                                fontSize: { xs: '24px', sm: '18px', md: '24px' },
                            }}
                        >
                            Property Wise Station
                        </Typography>

                        <Grid sx={{ display: 'flex', justifyContent: 'end' }}>
                            <CrudButtons
                                moduleName="Task Master"
                                mode={mode}
                                onAdd={handleAdd}
                                onEdit={handleEdit}
                                onView={handlePrint}
                                onDelete={handleDeleteClick}
                                onExit={handleExit}
                                onPrevious={handlePrevious}
                                onNext={handleNext}
                                readOnlyMode={isFormDisabled}
                                hideDelete={true}
                                hideAdd={true}
                            />
                        </Grid>
                    </Grid>

                    <Grid
                        item
                        xs={12}
                        className="form_field"
                        sx={{
                            display: 'flex',
                            justifyContent: 'center'
                        }}
                    >
                        <Box sx={{
                            width: '100%',
                            maxWidth: '900px',
                        }}>
                            <Grid container spacing={2} justifyContent="center">
                                <Grid item xs={12} md={6}>
                                    <FormControl variant="filled" fullWidth className="custom-textfield">
                                        <InputLabel id="property-label">Property</InputLabel>
                                        <Select
                                            labelId="property-label"
                                            id="Property"
                                            name="Property"
                                            value={formData.Property}
                                            onChange={handleInputChange}
                                        // disabled={isFormDisabled}
                                        >
                                            {dropdownData.map((item) => (
                                                <MenuItem key={item.id} value={item.id}>
                                                    {item.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>

                                </Grid>

                            </Grid>

                            <Grid container spacing={2} justifyContent="center" sx={{ mt: 0.1 }}>

                                {/* <Grid item xs={6} md={2.5} sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: { xs: 'flex-start', md: 'center' }
                                }}>
                                    <FormGroup>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    disabled={isFormDisabled}
                                                    checked={status === "1"}
                                                    onChange={handleChangeStatus}
                                                />
                                            }
                                            label="Status"
                                        />
                                    </FormGroup>
                                </Grid> */}


                            </Grid>
                        </Box>
                    </Grid>

                    <Grid item xs={12} className="form_field">
                        <Grid container spacing={1} justifyContent='center'>
                            <Grid item xs={12}>
                                <Box sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                }}>
                                    <Box sx={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        mb: 1
                                    }}>
                                        <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                                            Station List:
                                        </Typography>

                                        <TextField
                                            id="search-workarea"
                                            placeholder="Search Work Area or Station..."
                                            variant="outlined"
                                            size="small"
                                            sx={{
                                                width: '200px',
                                                '& .MuiOutlinedInput-root': {
                                                    height: '32px'
                                                },
                                                '& .MuiInputBase-input': {
                                                    padding: '6px 8px',
                                                    fontSize: '0.875rem'
                                                }
                                            }}
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                            disabled={isFormDisabled}
                                            InputProps={{
                                                endAdornment: searchQuery && (
                                                    <IconButton
                                                        size="small"
                                                        onClick={() => setSearchQuery('')}
                                                        sx={{ mr: -1, p: 0.5 }}
                                                        disabled={isFormDisabled}
                                                    >
                                                        <ClearIcon fontSize="small" />
                                                    </IconButton>
                                                ),
                                            }}
                                        />
                                    </Box>

                                    <Box sx={{
                                        display: 'grid',
                                        gridTemplateColumns: {
                                            xs: 'repeat(1, 1fr)',
                                            sm: 'repeat(2, 1fr)',
                                            md: 'repeat(3, 1fr)',
                                            lg: 'repeat(3, 1fr)'
                                        },
                                        maxHeight: '200px',
                                        overflowY: 'auto',
                                        padding: '8px',
                                        border: '1px solid #e0e0e0',
                                        borderRadius: '4px',
                                        backgroundColor: '#f9f9f9'
                                    }}>
                                        {hasRetrievedData ? (
                                            filteredRows.length > 0 ? (
                                                filteredRows.map((row) => (
                                                    <FormControlLabel
                                                        key={row.HkWrkStnId}
                                                        control={
                                                            <Checkbox
                                                                size="small"
                                                                checked={selectedWorkAreas.some(item => item.HkWrkStnId === row.HkWrkStnId)}
                                                                onChange={(e) => handleCheckboxChange(row, e.target.checked)}

                                                                sx={{
                                                                    '&.Mui-checked': {
                                                                        color: row.IsAllocated ? '#ff9800' : '#1976d2',
                                                                    }
                                                                }}
                                                            />
                                                        }
                                                        label={
                                                            <Typography variant="body2" sx={{
                                                                color: row.IsAllocated ? '#ff9800' : 'inherit',
                                                                fontWeight: row.IsAllocated ? 'bold' : 'normal'
                                                            }}>
                                                                {row.HkWrkStnName}
                                                                {row.Abrv && row.Abrv !== 'N/A' && ` (${row.Abrv})`}
                                                                {row.IsAllocated && ' ✓'}
                                                            </Typography>
                                                        }
                                                        sx={{
                                                            margin: 0,
                                                            '& .MuiFormControlLabel-label': {
                                                                fontSize: '0.875rem'
                                                            }
                                                        }}
                                                    />
                                                ))
                                            ) : (
                                                <Typography variant="body2" sx={{ gridColumn: '1/-1', textAlign: 'center', p: 2 }}>
                                                    No work stations found for this property
                                                </Typography>
                                            )
                                        ) : (
                                            <Typography variant="body2" sx={{ gridColumn: '1/-1', textAlign: 'center', p: 2 }}>
                                                Click "Retrieve" button to load work stations
                                            </Typography>
                                        )}
                                    </Box>

                                    {selectedWorkAreas.length > 0 && hasRetrievedData && (
                                        <Typography variant="caption" sx={{ mt: 1, color: 'text.secondary' }}>
                                            Selected: {selectedWorkAreas.length} work station(s)
                                        </Typography>
                                    )}
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className="form_button">
                        {mode === 'view' && (
                            <>
                                <Button
                                    variant="contained"
                                    sx={{ mr: 1, background: 'linear-gradient(290deg, #d4d4d4, #ffffff)' }}
                                    onClick={handleSubmit}
                                // disabled
                                >
                                    Submit
                                </Button>
                                <Button
                                    variant="contained"
                                    sx={{ mr: 1, background: 'linear-gradient(290deg, #a7c5e9, #ffffff)' }}
                                    onClick={handleCancel}
                                    disabled
                                >
                                    Cancel
                                </Button>
                            </>
                        )}
                        {(mode === 'edit' || mode === 'add') && (
                            <>
                                <Button variant="contained" sx={{
                                    mr: 1,
                                    background: "linear-gradient(290deg,   #b9d0e9, #e9f2fa)",
                                }} onClick={handleSubmit}>
                                    Submit
                                </Button>
                                <Button variant="contained" sx={{
                                    mr: 1,
                                    background: "linear-gradient(290deg,   #b9d0e9, #e9f2fa)",
                                }} onClick={handleCancel}>
                                    Cancel
                                </Button>
                            </>
                        )}
                    </Grid>
                </Grid>
            </Box>

            <div style={{ display: 'none' }}>
                {Object.keys(dataForPrint).length > 0 && (
                    <ReportTable
                        columns={columns}
                        rows={rows}
                        title="Work Area Master"
                        contentRef={contentRef}
                        customStyles={{ backgroundColor: '#f5f5f5' }}
                    />
                )}
            </div>

            <Dialog
                open={deleteConfirmDialog}
                onClose={handleCancelDeleteStation}
                aria-labelledby="delete-station-dialog-title"
                aria-describedby="delete-station-dialog-description"
            >
                <DialogTitle id="delete-station-dialog-title">
                    {"Remove Station from Property?"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="delete-station-dialog-description">
                        Are you sure you want to remove "{stationToDelete?.station?.HkWrkStnName}" from this property?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        sx={{
                            backgroundColor: '#635bff',
                            color: 'white',
                            '&:hover': { backgroundColor: '#1565c0', color: 'white' },
                        }}
                        onClick={handleConfirmDeleteStation}
                    >
                        Remove
                    </Button>
                    <Button
                        sx={{
                            backgroundColor: '#dc3545',
                            color: 'white',
                            '&:hover': { backgroundColor: '#c82333', color: 'white' },
                        }}
                        onClick={handleCancelDeleteStation}
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default PropertyWisestation;